import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowClassicContentService {
  private showClassicContent = new BehaviorSubject<boolean>(false);
  private openChat = new Subject<void>();

  public showClassicContent$ = this.showClassicContent.asObservable();
  public openChat$ = this.openChat.asObservable();

  setShow(show: boolean): void {
    // The event gets emitted during view construction, so wait until the view is fully rendered
    // before updating the value to prevent throwing the error
    // `NG0100: Expression has changed after it was checked` by delaying emission only when
    // setting to true
    if (show) {
      setTimeout(() => this.showClassicContent.next(show));
      return;
    }

    this.showClassicContent.next(show);
  }

  setOpenChat(): void {
    this.openChat.next();
  }
}
